import React, { useLayoutEffect, useRef, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import StyledCredit from "./styled/credit";
import StyledCaption from "./styled/caption";

const Artifact = ({ children, callBack = undefined, isInline = undefined, inlineIsActive = undefined }) => {
  const observerRef = useRef();
  const [isActive, setIsActive] = useState(false);

  function handleIntersect(entries, observer) {
    ( entries[0].intersectionRatio < 1 ) ? setIsActive(false) : setIsActive(true);
  }

  function setupObserver(el) {
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0.9,1]
    };
    observer = new IntersectionObserver( handleIntersect, options );
    observer.observe(el);
  }

  useEffect(() => {
    callBack && callBack( isActive );
  },[isActive])

  useEffect(() => {
    ! isInline && observerRef.current && setupObserver( observerRef.current );
  }, []);

  useEffect(() => {
    isInline && setIsActive( inlineIsActive );
  }, [inlineIsActive]);

  return (
    <StyledArtifact ref={observerRef}  className={isActive && 'is-active'} isInline={isInline}>
      {children}
    </StyledArtifact>
  )
};

export default Artifact;



const StyledArtifact = styled.aside`
  position: absolute;
  left: calc(100% + (1 * var(--gutter)));
  width: calc(((100vw - (var(--text-max-width)))/2) - (1.5 * var(--gutter)));
  max-width: 20em;
  padding: 0 0 10vh;
  margin-top: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-family: var(--font-sans);
  ${props => props.isInline === "true" && css`
    right: auto;
    left: calc(100% + var(--gutter));
    transform: translate3d(0,-50%,0);
    padding-bottom: 0;
  `}
  &.is-active {
    opacity: 1;
  }
  ${StyledCredit} {
    position: absolute;
    bottom: calc(100% + 0.5em);
  }
  ${StyledCaption} {
    font-size: 0.875em;
    text-align: left;
    margin-top: -0.375em;
    font-family: var(--font-sans);
  }
  @media (max-width: 48em) {
    display: none;
  }
`;
export { StyledArtifact };